<template>
    <div class="container" @click="cancelWarp">
        <header>
            <a href="http://en.senkemotor.com"><img src="https://www.senkemotor.com/skin/motor/images/logo/logo_6.png" alt="senkelogo" class="h_img"></a>
        </header>
        <div class="warp" v-show="showWarp" :style="{background:isSubmit}">
            <span class="msg_p" style="opcity:1;width:100vw;">{{warpMsg}}</span>
        </div>
        <p style="font-weight:bold;font-size:26px;"> BECOME A DEALER</p>
        <div>
            <p style="font-weight:bold;font-size:18px;">Please fill in your information</p>
        </div>
        <div class="msg_content" v-for="(v,k) in msg">
            <div class="msg_item">
                <div class="title"><p class="msg_p" style="width:100%;">{{k}}：</p></div>
                <input class="msg_input" type="text" :name="k" placeholder="*" v-model="msg[k]">
            </div>
        </div>
        <div class="country msg_item">
            <div class="title"><p class="msg_p" style="width:100%;">Country：</p></div>
            <input class="msg_input" type="text" list="countryList" placeholder="*" v-model="Country" @click="delCountry">
            <datalist id="countryList">
                <option v-for="c in countryArr">{{c.value}}&nbsp;&nbsp;{{c.label}}</option>
            </datalist>
        </div>
        <div class="msg_detail">
            <div class="title"><span class="msg_p" style="width:100%;">Detail:</span></div>
            <textarea name="detail" id="detail" rows="20" style="width:100%;" v-model="detail">{{detail}}</textarea>
        </div>
        <div class="identify">
            <div class="identify_img">
                <img :src="imgSrc"  alt="identify" @click="refreshImg" ref="identify_img">
            </div>
            <span class="msg_p" style="width:100%;">Please enter the verification code：</span>
            <input type="text" class="msg_input" v-model="identifyNum" style="margin:0;">
        </div>
        <div class="submit">
            <button class="submitBtn"  @click.stop="submitMsg">SUBMIT</button>
        </div>
        <footer>
            <div class="contact">
                <a href="https://www.facebook.com/SENKEMOTORCYCLE/?eid=ARBbheIA9Nps3xWFYZjH9MgTX6roeUMUXCDk0fuekvuiMOsv_EtwQp6i3REA0VrgjjIxeGS0chi4N7-c"><img src="../img/fb.png" alt="fb"></a>
                <a href="https://www.youtube.com/channel/UCoWPGF31Rym__3-uN5d4bHA?view_as=subscriber"><img src="../img/yb.png" alt="yb"></a>
                <a href="https://www.linkedin.com/company/senke-motorcycle/?viewAsMember=true"><img src="../img/lk.png" alt="lk"></a>
            </div>
            Copyright © 2018 鹤山国机南联摩托车工业有限公司 by<a href="http://www.senkemotor.com/" target="_blank"> SENKEMOTOR.</a> All Rights Reserved.<a href="http://www.beian.miit.gov.cn">粤ICP备14006258号</a>
        </footer>
    </div>
</template>

<script>
import axios from 'axios'
import Footer from '../component/footer'
export default {
    name: 'dealer',
    components: {
        Footer
    },
    data(){
        return{
            msg: {
                "Your Name": "",
                "Phone Number": "",
                "E-Mail": "",
                "Company": ""
            },
            warpMsg: '',
            showWarp: false,
            detail: "",
            Country: "",
            imgUrl: 'https://www.senkemotor.com/skin/motor/DEALER/identifyImg.php',
            imgSrc: '',
            countryArr: [
                {
                    "value":"AA",
                    "label":"America"
                },
                {
                    "value":"AD",
                    "label":"Andorra"
                },
                {
                    "value":"AE",
                    "label":"United Arab Emirates"
                },
                {
                    "value":"AF",
                    "label":"Afghanistan"
                },
                {
                    "value":"AG",
                    "label":"Antigua and Barbuda"
                },
                {
                    "value":"AL",
                    "label":"Albania"
                },
                {
                    "value":"AM",
                    "label":"Armenia"
                },
                {
                    "value":"AO",
                    "label":"Angola"
                },
                {
                    "value":"AR",
                    "label":"Argentina"
                },
                {
                    "value":"AT",
                    "label":"Austria"
                },
                {
                    "value":"AU",
                    "label":"Australia"
                },
                {
                    "value":"AW",
                    "label":"Aruba"
                },
                {
                    "value":"AZ",
                    "label":"Azerbaijan"
                },
                {
                    "value":"BA",
                    "label":"Bosnia and Herzegovina"
                },
                {
                    "value":"BB",
                    "label":"Barbados"
                },
                {
                    "value":"BD",
                    "label":"Bangladesh"
                },
                {
                    "value":"BE",
                    "label":"Belgium"
                },
                {
                    "value":"BF",
                    "label":"Burkina Faso"
                },
                {
                    "value":"BG",
                    "label":"Bulgaria"
                },
                {
                    "value":"BH",
                    "label":"Bahrain"
                },
                {
                    "value":"BI",
                    "label":"Burundi"
                },
                {
                    "value":"BJ",
                    "label":"Benin"
                },
                {
                    "value":"BM",
                    "label":"Bermuda"
                },
                {
                    "value":"BN",
                    "label":"Brunei"
                },
                {
                    "value":"BO",
                    "label":"Bolivia"
                },
                {
                    "value":"BR",
                    "label":"Brazil"
                },
                {
                    "value":"BS",
                    "label":"Bahamas"
                },
                {
                    "value":"BT",
                    "label":"Bhutan"
                },
                {
                    "value":"BW",
                    "label":"Botswana"
                },
                {
                    "value":"BY",
                    "label":"Belarus"
                },
                {
                    "value":"BZ",
                    "label":"Belize"
                },
                {
                    "value":"CA",
                    "label":"Canada"
                },
                {
                    "value":"CD",
                    "label":"Democratic Republic of the Congo"
                },
                {
                    "value":"CF",
                    "label":"Central African Republic"
                },
                {
                    "value":"CG",
                    "label":"Democratic Republic of the Congo"
                },
                {
                    "value":"CH",
                    "label":"Switzerland"
                },
                {
                    "value":"CL",
                    "label":"Chile"
                },
                {
                    "value":"CM",
                    "label":"Cameroon"
                },
                {
                    "value":"CN",
                    "label":"China"
                },
                {
                    "value":"CO",
                    "label":"Colombia"
                },
                {
                    "value":"CR",
                    "label":"Costa Rica"
                },
                {
                    "value":"CU",
                    "label":"Cuba"
                },
                {
                    "value":"CV",
                    "label":"Cape Verde"
                },
                {
                    "value":"CY",
                    "label":"Cyprus"
                },
                {
                    "value":"CZ",
                    "label":"Czech Republic"
                },
                {
                    "value":"DE",
                    "label":"Germany"
                },
                {
                    "value":"DJ",
                    "label":"Djibouti"
                },
                {
                    "value":"DK",
                    "label":"Denmark"
                },
                {
                    "value":"DM",
                    "label":"Dominica"
                },
                {
                    "value":"DO",
                    "label":"Dominican Republic"
                },
                {
                    "value":"DZ",
                    "label":"Algeria"
                },
                {
                    "value":"EC",
                    "label":"Ecuador"
                },
                {
                    "value":"EE",
                    "label":"Estonia"
                },
                {
                    "value":"EG",
                    "label":"Egypt"
                },
                {
                    "value":"ER",
                    "label":"Eritrea"
                },
                {
                    "value":"ES",
                    "label":"Spain"
                },
                {
                    "value":"ET",
                    "label":"Ethiopia"
                },
                {
                    "value":"FI",
                    "label":"Finland"
                },
                {
                    "value":"FJ",
                    "label":"Fiji"
                },
                {
                    "value":"FK",
                    "label":"Falkland Islands"
                },
                {
                    "value":"FM",
                    "label":"Micronesia"
                },
                {
                    "value":"FO",
                    "label":"Faroe Islands"
                },
                {
                    "value":"FR",
                    "label":"France"
                },
                {
                    "value":"GA",
                    "label":"Gabon"
                },
                {
                    "value":"GB",
                    "label":"United Kingdom"
                },
                {
                    "value":"GD",
                    "label":"Grenada"
                },
                {
                    "value":"GE",
                    "label":"Georgia"
                },
                {
                    "value":"GH",
                    "label":"Ghana"
                },
                {
                    "value":"GI",
                    "label":"Gibraltar"
                },
                {
                    "value":"GM",
                    "label":"Gambia"
                },
                {
                    "value":"GN",
                    "label":"Guinea"
                },
                {
                    "value":"GQ",
                    "label":"Equatorial Guinea"
                },
                {
                    "value":"GR",
                    "label":"Greece"
                },
                {
                    "value":"GT",
                    "label":"Guatemala"
                },
                {
                    "value":"GW",
                    "label":"Guinea-Bissau"
                },
                {
                    "value":"GY",
                    "label":"Guyana"
                },
                {
                    "value":"HK",
                    "label":"Hong Kong"
                },
                {
                    "value":"HN",
                    "label":"Honduras"
                },
                {
                    "value":"HR",
                    "label":"Croatia"
                },
                {
                    "value":"HT",
                    "label":"Haiti"
                },
                {
                    "value":"HU",
                    "label":"Hungary"
                },
                {
                    "value":"ID",
                    "label":"Indonesia"
                },
                {
                    "value":"IE",
                    "label":"Ireland"
                },
                {
                    "value":"IL",
                    "label":"Israel"
                },
                {
                    "value":"IN",
                    "label":"India"
                },
                {
                    "value":"IQ",
                    "label":"Iraq"
                },
                {
                    "value":"IR",
                    "label":"Iran"
                },
                {
                    "value":"IS",
                    "label":"Iceland"
                },
                {
                    "value":"IT",
                    "label":"Italy"
                },
                {
                    "value":"JM",
                    "label":"Jamaica"
                },
                {
                    "value":"JO",
                    "label":"Jordan"
                },
                {
                    "value":"JP",
                    "label":"Japan"
                },
                {
                    "value":"KE",
                    "label":"Kenya"
                },
                {
                    "value":"KG",
                    "label":"Kyrgyzstan"
                },
                {
                    "value":"KH",
                    "label":"Cambodia"
                },
                {
                    "value":"KI",
                    "label":"Kiribati"
                },
                {
                    "value":"KM",
                    "label":"Comoros"
                },
                {
                    "value":"KN",
                    "label":"Saint Kitts and Nevis"
                },
                {
                    "value":"KP",
                    "label":"North Korea"
                },
                {
                    "value":"KR",
                    "label":"South Korea"
                },
                {
                    "value":"KW",
                    "label":"Kuwait"
                },
                {
                    "value":"KY",
                    "label":"Cayman Islands"
                },
                {
                    "value":"KZ",
                    "label":"Kazakhstan"
                },
                {
                    "value":"LA",
                    "label":"Laos"
                },
                {
                    "value":"LB",
                    "label":"Lebanon"
                },
                {
                    "value":"LC",
                    "label":"Saint Lucia"
                },
                {
                    "value":"LI",
                    "label":"Liechtenstein"
                },
                {
                    "value":"LK",
                    "label":"Sri Lanka"
                },
                {
                    "value":"LR",
                    "label":"Liberia"
                },
                {
                    "value":"LS",
                    "label":"Lesotho"
                },
                {
                    "value":"LT",
                    "label":"Lithuania"
                },
                {
                    "value":"LU",
                    "label":"Luxembourg"
                },
                {
                    "value":"LV",
                    "label":"Latvia"
                },
                {
                    "value":"LY",
                    "label":"Libya"
                },
                {
                    "value":"MA",
                    "label":"Morocco"
                },
                {
                    "value":"MC",
                    "label":"Monaco"
                },
                {
                    "value":"MD",
                    "label":"Moldova"
                },
                {
                    "value":"ME",
                    "label":"Montenegro"
                },
                {
                    "value":"MG",
                    "label":"Madagascar"
                },
                {
                    "value":"MK",
                    "label":"Macedonia"
                },
                {
                    "value":"ML",
                    "label":"Mali"
                },
                {
                    "value":"MM",
                    "label":"Myanmar"
                },
                {
                    "value":"MN",
                    "label":"Mongolia"
                },
                {
                    "value":"MO",
                    "label":"Macao"
                },
                {
                    "value":"MR",
                    "label":"Mauritania"
                },
                {
                    "value":"MT",
                    "label":"Malta"
                },
                {
                    "value":"MU",
                    "label":"Mauritius"
                },
                {
                    "value":"MV",
                    "label":"Maldives"
                },
                {
                    "value":"MW",
                    "label":"Malawi"
                },
                {
                    "value":"MX",
                    "label":"Mexico"
                },
                {
                    "value":"MY",
                    "label":"Malaysia"
                },
                {
                    "value":"MZ",
                    "label":"Mozambique"
                },
                {
                    "value":"NA",
                    "label":"Namibia"
                },
                {
                    "value":"NE",
                    "label":"Niger"
                },
                {
                    "value":"NG",
                    "label":"Nigeria"
                },
                {
                    "value":"NI",
                    "label":"Nicaragua"
                },
                {
                    "value":"NL",
                    "label":"Netherlands"
                },
                {
                    "value":"NO",
                    "label":"Norway"
                },
                {
                    "value":"NP",
                    "label":"Nepal"
                },
                {
                    "value":"NR",
                    "label":"Nauru"
                },
                {
                    "value":"NZ",
                    "label":"New Zealand"
                },
                {
                    "value":"OM",
                    "label":"Oman"
                },
                {
                    "value":"PA",
                    "label":"Panama"
                },
                {
                    "value":"PE",
                    "label":"Peru"
                },
                {
                    "value":"PG",
                    "label":"Papua New Guinea"
                },
                {
                    "value":"PH",
                    "label":"Philippines"
                },
                {
                    "value":"PK",
                    "label":"Pakistan"
                },
                {
                    "value":"PL",
                    "label":"Poland"
                },
                {
                    "value":"PR",
                    "label":"Puerto Rico"
                },
                {
                    "value":"PS",
                    "label":"Palestine"
                },
                {
                    "value":"PT",
                    "label":"Portugal"
                },
                {
                    "value":"PW",
                    "label":"Palau"
                },
                {
                    "value":"PY",
                    "label":"Paraguay"
                },
                {
                    "value":"QA",
                    "label":"Qatar"
                },
                {
                    "value":"RO",
                    "label":"Romania"
                },
                {
                    "value":"RS",
                    "label":"Serbia"
                },
                {
                    "value":"RU",
                    "label":"Russia"
                },
                {
                    "value":"RW",
                    "label":"Rwanda"
                },
                {
                    "value":"SA",
                    "label":"Saudi Arabia"
                },
                {
                    "value":"SB",
                    "label":"Solomon Islands"
                },
                {
                    "value":"SC",
                    "label":"Seychelles"
                },
                {
                    "value":"SD",
                    "label":"Sudan"
                },
                {
                    "value":"SE",
                    "label":"Sweden"
                },
                {
                    "value":"SG",
                    "label":"Singapore"
                },
                {
                    "value":"SI",
                    "label":"Slovenia"
                },
                {
                    "value":"SK",
                    "label":"Slovak Republic"
                },
                {
                    "value":"SL",
                    "label":"Sierra Leone"
                },
                {
                    "value":"SM",
                    "label":"San Marino"
                },
                {
                    "value":"SN",
                    "label":"Senegal"
                },
                {
                    "value":"SO",
                    "label":"Somalia"
                },
                {
                    "value":"SR",
                    "label":"Suriname"
                },
                {
                    "value":"ST",
                    "label":"Sao Tome and Principe"
                },
                {
                    "value":"SV",
                    "label":"El Salvador"
                },
                {
                    "value":"SY",
                    "label":"Syria"
                },
                {
                    "value":"SZ",
                    "label":"Swaziland"
                },
                {
                    "value":"TD",
                    "label":"Chad"
                },
                {
                    "value":"TG",
                    "label":"Togo"
                },
                {
                    "value":"TH",
                    "label":"Thailand"
                },
                {
                    "value":"TJ",
                    "label":"Tajikistan"
                },
                {
                    "value":"TM",
                    "label":"Turkmenistan"
                },
                {
                    "value":"TN",
                    "label":"Tunisia"
                },
                {
                    "value":"TO",
                    "label":"Tonga"
                },
                {
                    "value":"TR",
                    "label":"Turkey"
                },
                {
                    "value":"TT",
                    "label":"Trinidad and Tobago"
                },
                {
                    "value":"TV",
                    "label":"Tuvalu"
                },
                {
                    "value":"TW",
                    "label":"Taiwan"
                },
                {
                    "value":"TZ",
                    "label":"Tanzania"
                },
                {
                    "value":"UA",
                    "label":"Ukraine"
                },
                {
                    "value":"UG",
                    "label":"Uganda"
                },
                {
                    "value":"UY",
                    "label":"Uruguay"
                },
                {
                    "value":"UZ",
                    "label":"Uzbekistan"
                },
                {
                    "value":"VC",
                    "label":"Saint Vincent And The Grenadine"
                },
                {
                    "value":"VE",
                    "label":"Venezuela"
                },
                {
                    "value":"VG",
                    "label":"British Virgin Islands"
                },
                {
                    "value":"VN",
                    "label":"Vietnam"
                },
                {
                    "value":"VU",
                    "label":"Vanuatu"
                },
                {
                    "value":"WF",
                    "label":"Wallis and Futuna"
                },
                {
                    "value":"WS",
                    "label":"Western Samoa"
                },
                {
                    "value":"YE",
                    "label":"Yemen"
                },
                {
                    "value":"ZA",
                    "label":"South Africa"
                },
                {
                    "value":"ZM",
                    "label":"Zambia"
                }],
            identifyNum: '',
            detail: '',
            fill: false,
            isSubmit: "red"
        }
    },
    mounted(){
        let that = this 
        that.imgSrc = that.imgUrl
    },
    methods:{
        delCountry(){
            this.Country = ""
        },
        submitMsg(){
            let that = this
            that.showWarp = true
            let data = new Object()
            data = {
                "Your Name": that.msg["Your Name"],
                "Phone Number": that.msg["Phone Number"],
                "E-Mail": that.msg["E-Mail"],
                "Company": that.msg["Company"],
                "Country": that.Country,
                "identifyNum": that.identifyNum
            }
            for(let i in data){
                if(data[i].trim() == ''){
                    that.isSubmit = "red"
                    that.warpMsg = 'Please enter '+ i
                    that.fill = false
                    break
                }else{
                    that.fill = true
                    continue
                }
            }
            if(that.fill == true){
                data.detail = that.detail
                axios({
                    method: 'post',
                    url: 'https://www.senkemotor.com/skin/motor/DEALER/idMsgCheck.php',
                    data: data,
                    transformRequest: [function (data) {
                        let ret = ''
                        for (let it in data) {
                            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
                        }
                        return ret
                    }],
                    headers: {'Content-Type': 'application/x-www-form-urlencoded'}
                })
                .then(res=>{
                    console.log(res.data)
                    if(res.data == "1"){
                        that.isSubmit = "green"
                        that.warpMsg = 'Submitted successfully'
                        setTimeout(()=>{
                            that.showWarp = false
                        },1000)
                    }else if(res.data == "0"){
                        that.refreshImg()
                        that.isSubmit ="red"
                        that.warpMsg = 'Error in verification code'
                    }else if(res.data == "2"){
                        that.refreshImg()
                        that.warpMsg = 'the phone number has request'
                    }
                })
                .catch(err=>{console.log(err)})
            }
        },
        refreshImg(){
            this.$refs.identify_img.src= this.imgUrl
        },
        cancelWarp(){
            this.showWarp = false
        }
    }
}
</script>


<style scoped>
    .title{
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
    }
    footer{
        background-color: rgb(65, 65, 65);
        margin-top: 10px;
        color: rgb(194, 189, 189);
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .identify_img img{
        width: 20vw;
    }
    footer a{
        color: white;
    }
    header{
        width: 100%;
        background-color: #fff;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
    }
    .h_img{
        margin-left: 20vh;
        width: 26.88vh;
        height: 10vh;
    }
    .contact{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        margin-top: 10px;
        margin-bottom: 10px;
    }
    .contact img{
        border-radius: 15px;
        height: 30px;
        width: 30px;
        margin-right: 20px;
    }
    .submitBtn{
        margin-top:20px;
        width:120px;
        height:5vh;
        border-radius: 10px;
    }
    .submitBtn:hover{
        background-color: green;
    }
    input{
        background-color: rgb(255, 255, 255);
    }
    .warp{
        position: fixed;
        bottom:40%;
        left: 0;
        z-index: 9999;
        width: 100vw;
        height: 20vw;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }
    .container{
        width: 100vw;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-color: rgb(145, 168, 194);
    }
    .msg_content{
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .msg_item{
        width: 70%;
        margin-bottom: 20px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
    }
    .msg_p{
        width:20%;
        text-align: center;
        font-size: 20px;
        font-weight:bold;
    }
    .msg_input{
        width:70%;
        margin:0 auto;
        height:40px;
    }
    .msg_detail{
        width: 70%;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
    }
    .msg_detail span{
        margin-bottom: 10px;
        margin-top: 20px;
    }
    @media screen and (max-width:560px){
        .identify_img img{
            width: 40vw;
        }
        .msg_item{
            width: 95%;
            margin-bottom: 20px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
        }
        .msg_p{
            width:10vw;
            text-align: center;
            font-size: 20px;
            font-weight:bold;
        }
        .msg_input{
            width:90%;
            margin:0 auto;
            height:40px;
        }
        header{
            flex-direction: column;
        }
        .h_img{
            margin-left: 0;
        }
    }
    .identify{
        width: 70%;
        margin:20px 0 20px 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
</style>


// WEBPACK FOOTER //
// src/page/dealer.vue